import React from 'react';
import { Header } from './Header';
import { Main } from './Main';
const Page = (props) => {
    return (React.createElement("div", { className: "page" },
        React.createElement("header", null,
            React.createElement(Header, { name: props.kreeda.kreedaData?.name, type: props.kreeda.kreedaType, duration: props.kreeda.kreedaData.duration })),
        React.createElement("main", null,
            React.createElement(Main, { ...props })),
        React.createElement("footer", null, "\u00A9 GyaanKreeda 2025")));
};
export { Page };
